import { Expose, Type } from "class-transformer";
import { IsArray, IsOptional, IsString, ValidateNested } from "class-validator";

export class ContractorBranchResponse {
  @Expose()
  @IsString()
  @IsOptional()
  parentContractorId!: string | null;
  @Expose()
  @IsString()
  parentContractorShortName!: string;
  @Expose()
  @IsString()
  parentContractorName!: string;
  @Expose()
  @IsString()
  parentContractorTIN!: string;
  @Expose()
  @IsArray()
  @Type(() => BranchContractor)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  branchContractors!: Array<BranchContractor>;
}

export class BranchContractor {
  @Expose()
  @IsString()
  branchContractorId!: string;
  @Expose()
  @IsString()
  branchContractorShortName!: string;
  @Expose()
  @IsString()
  branchContractorName!: string;
  @Expose()
  @IsString()
  branchContractorTIN!: string;
}
